// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"141":"contacts-page","223":"home-page"}[chunkId] + "." + {"141":"ff863922","223":"386bc0cf"}[chunkId] + ".chunk.css";
};